import { Button, Form, Input, Modal, Space } from "antd";
import { FontFa } from "../../../../../components";
import _ from "lodash";
import { useCreateDocumentTag } from "../hooks/useCreateDocumentTag";
import { useState } from "react";
import { useUpdateDocumentTag } from "../hooks/useUpdateDocumentTag";
import { useDeleteDocumentTag } from "../hooks/useDeleteDocumentTag";

type Tag = {
  id: string;
  Title: string;
  eTagType: string;
};

type InitialType = {
  tags: Tag[];
  tagType: string;
};

export const DocumentTagForm = ({ initialValue }: { initialValue: InitialType }) => {
  const [form] = Form.useForm();
  const { createDocumentTag, isLoading } = useCreateDocumentTag();
  const { updateDocumentTag, isLoading: isUpdateLoading } = useUpdateDocumentTag();
  const { deleteDocumentTag, isLoading: isDeleteLoading } = useDeleteDocumentTag();
  const [editingKey, setEditingKey] = useState("");

  const isEditable = (key: number) => key + "" === editingKey;

  const onFinish = (values: InitialType) => {
    const newTagValues = values.tags.map((e) => ({ ...e, eTagType: initialValue.tagType }));
    const diffArr = _.differenceWith(newTagValues, initialValue.tags, _.isEqual);
    diffArr.forEach((e) => {
      const fields = {
        Title: e.Title,
        eTagType: e.eTagType,
      };
      createDocumentTag(fields);
      form.setFieldValue("tags", newTagValues);
    });
  };

  const edit = (key: number) => {
    setEditingKey(key + "");
  };

  const save = (record: any) => {
    const { id, ...body } = record;
    updateDocumentTag({ id: id, body: body });
    setEditingKey("");
  };

  const onRemove = (id: string, remove: (itemName: number) => void, name: number) => {
    if (id) {
      Modal.confirm({
        title: "Thông báo",
        content: "Anh/chị vui lòng xác nhận xoá các dữ liệu đã chọn!",
        okText: "Xác nhận",
        okType: "danger",
        okButtonProps: { type: "primary" },
        cancelText: "Huỷ",
        onOk: () => {
          deleteDocumentTag(id);
          remove(name);
        },
      });
    } else {
      remove(name);
    }
  };

  const handleKeyDown = (event: any) => {
    if (event.keyCode === 13) {
      event.preventDefault();
    }
  };

  return (
    <Form form={form} name="dynamic_form_nest_item" onFinish={onFinish} autoComplete="off" initialValues={initialValue}>
      <Form.List name="tags">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => {
              const disabled = isEditable(key);
              const isNew = !!form.getFieldValue(["tags", name, "eTagType"]);
              return (
                <Space key={key} style={{ display: "flex", marginBottom: 8 }} align="baseline">
                  <Form.Item
                    {...restField}
                    name={[name, "Title"]}
                    rules={[{ required: true, message: "Vui lòng nhập chủ đề!" }]}
                  >
                    <Input
                      placeholder="Vui lòng nhập chủ đề!"
                      disabled={!disabled && isNew}
                      onKeyDown={handleKeyDown}
                    />
                  </Form.Item>
                  {isNew ? (
                    !disabled ? (
                      <>
                        <Button
                          icon={
                            <FontFa
                              name="faEdit"
                              style={{ cursor: "pointer", color: "#34e5eb" }}
                              onClick={() => edit(key)}
                            />
                          }
                          type="text"
                        />
                        <Button
                          icon={<FontFa name="faMinusCircle" style={{ cursor: "pointer", color: "#F64E6E" }} />}
                          onClick={() => onRemove(form.getFieldValue(["tags", name, "id"]), remove, name)}
                          disabled={isDeleteLoading}
                          type="text"
                        />
                      </>
                    ) : (
                      <>
                        <Button
                          icon={<FontFa name="faSave" style={{ cursor: "pointer", color: "#26EC5F" }} />}
                          onClick={() => save(form.getFieldValue(["tags", name]))}
                          disabled={isUpdateLoading}
                          type="text"
                        />
                        <Button
                          icon={<FontFa name="faTimes" style={{ cursor: "pointer", color: "#F64E6E" }} />}
                          onClick={() => setEditingKey("")}
                          disabled={isUpdateLoading}
                          type="text"
                        />
                      </>
                    )
                  ) : (
                    <></>
                  )}
                </Space>
              );
            })}
            <Form.Item>
              <Button
                type="dashed"
                onClick={() => add()}
                block
                icon={<FontFa name="faPlus" className="text-success" />}
              >
                {`Thêm chủ đề mới`}
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
      <Form.Item>
        <Button type="primary" htmlType="submit" disabled={isLoading}>
          Xác nhận
        </Button>
      </Form.Item>
    </Form>
  );
};
